
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftBottom25 as ObiThreewayAnalogInleftBottom25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-bottom-25.js';
 
 
 

 
 export const ObiThreewayAnalogInleftBottom25 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-bottom-25',
   elementClass: ObiThreewayAnalogInleftBottom25Element,
   events: {
     
   }
  });
 
 